import type { ReactNode } from 'react';

export const symbol_arrow_cool_down: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M469-85q-5-2-10-7L221-330q-9-9-9-21t9-21q9-9 21-9t21 9l187 187v-276q0-13 8.5-21.5T480-491q13 0 21.5 8.5T510-461v276l187-187q9-9 21-9t21 9q9 9 9 21t-9 21L501-92q-5 5-10 7t-11 2q-6 0-11-2Zm-10.5-474.5Q450-568 450-581v-80q0-13 8.5-21.5T480-691q13 0 21.5 8.5T510-661v81q0 13-8.5 21t-21.5 8q-13 0-21.5-8.5Zm0-200Q450-768 450-781v-60q0-13 8.5-21.5T480-871q13 0 21.5 8.5T510-841v61q0 13-8.5 21t-21.5 8q-13 0-21.5-8.5Z"
		/>
	</svg>
);
